import { Result } from '@cplug/frontend-core/utils'
import { type DataWrappedDTO } from '@cplug/frontend-core/gateways'
import { FirebaseProject, type FirebaseCredentials } from '../models/FirebaseCredentials'
import { FirebaseCredentialsDTO, mapDTOToFirebaseCredentials } from './DTOs/FirebaseCredentialsDTO'
import CPBaseGateway from '~/shared/gateways/CPBaseGateway'

export class CPFirebaseCredentialsGateway extends CPBaseGateway {
  async getToken (): Promise<Result<FirebaseCredentials>> {
    const response = await this.post<DataWrappedDTO<FirebaseCredentialsDTO>>('firebase/credentials/token', {
      project: FirebaseProject.GESTAO
    })

    return this.parseSingleResponse(response, FirebaseCredentialsDTO, (dto: FirebaseCredentialsDTO) =>
      Result.ofValue(mapDTOToFirebaseCredentials(dto))
    )
  }
}
